import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

class BlogArticle {
	id: number;
	body: string;
	summary: string;
	title: string;
	slug: Date;
	date: Date;
	picture: string;
	description: string;
	keywords: string;
	alt: string;
}

@Component({
	selector: 'ras-blog-page',
	templateUrl: './blog-page.component.html',
	styleUrls: ['./blog-page.component.sass']
})
export class BlogPageComponent implements OnInit {

	public articles: BlogArticle[] = null

	load_articles(): Promise<BlogArticle[]> {
		return new Promise<BlogArticle[]>((resolve, reject) => {
			this.http
			.get("https://rentastore.co.za/articles")
			.toPromise()
			.then((response: any) => {
				let articles: BlogArticle[] = []
				for (let item of response) {
					let article = <BlogArticle> {
						id: item.id,
						body: item.Body,
						summary: item.Summary,
						title: item.Title,
						slug: item.Slug,
						date: item.Date,
						picture: item.Picture.url,
						alt: item.PictureAltText
					}
					articles.push(article)
				}
				articles.sort((a, b) => (a.date < b.date) ? 1 : (a.date > b.date) ? -1 : 0 )
				resolve(articles)
			})
		})
	}

	constructor(private http: HttpClient, private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('blog')

		this.load_articles()
		.then(articles => this.articles = articles)
		.catch(reason => console.log("promise failed", reason))
	}

}
